<template>
  <section class="residency__events">
    <v-container>
      <v-heading level="h3">Congressos e Eventos da Radiologia</v-heading>
      <div class="featured">
        <a :href="events.featured.href" target="_blank">
          <img :src="events.featured.img" alt="Destaque">
        </a>
      </div>
      <ul>
        <li v-for="(event, index) in events.items" :key="index">
          <a :href="event.href" target="_blank">
            <span class="date">
              <span class="date__day">{{event.day}}</span>
              <span class="date__month">{{event.month}}</span>
            </span>
            <span class="title">{{event.title}}</span>
            <img src="@/assets/img/arrow.svg" :alt="event.title">
          </a>
        </li>
      </ul>
    </v-container>
  </section>
</template>

<script>
import Vue from 'vue';
import Container from '@/components/layout/Container.vue';
import Loader from '@/components/layout/Loader.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Mockup from '@/components/uikit/mockup/Mockup.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';

export default {
  name: 'Residency-Events',
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'v-loader': Loader,
    'v-mockup': Mockup,
    'body-text': BodyText,
  },
  props: {
    events: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.residency__events';
#{$component} {
  padding: $section-gutter 0;
  text-align: center;
  h3.heading, {
    margin-bottom: $gutter-xxl;
    color: $color-d;
  }
  .featured {
    margin-bottom: $gutter-xxl;
    a {
      img {
        display: block;
        max-width: 100%;
        transition: opacity $transition-duration $transition-timing-function;
      }
      &:hover img {
        opacity: 0.9;
      }
    }
  }
  ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: $gutter-l;
    align-items: center;
    width: 100%;
    text-align: left;
    @media screen and (max-width: #{$brakepoint-medium}) {
      display: block;
    }
    li {
      @media screen and (max-width: #{$brakepoint-medium}) {
        margin-bottom: $gutter-l;
      }
      &::nth-child(n+1) {
        grid-column: 1 / 2;
      }
      &::nth-child(n+2) {
        grid-column: 2 / 3;
      }
      &::nth-child(n+3) {
        grid-column: 3 / 4;
      }
      a {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border-radius: $gutter;
        background-color: white;
        box-shadow: $box-shadow;
        width: 100%;
        min-height: 72px;
        padding: $gutter-l;
        transition: box-shadow $transition-duration $transition-timing-function,
          transform $transition-duration $transition-timing-function;
        text-decoration: none;
        &:hover {
          box-shadow: $box-shadow-l;
          transform: translateY(#{-$gutter/2});
        }
        * {
          padding: 0 $gutter;
        }
        .date {
          text-align: center;
          * {
            display: block;
            color: $color-sys-f;
            font-weight: $font-weight-bold;
            line-height: $line-height;
            font-size: $font-size;
          }
          &__day {
            margin-bottom: $gutter / 2;
          }
          &__month {
            font-size: $font-size-s;
          }
        }
        .title {
          width: 100%;
          box-sizing: border-box;
          line-height: $line-height-l;
          font-weight: $font-weight-bold;
          color: $color-sys-b;
        }
      }
    }
  }
}
</style>
